import React, { useMemo } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';
import AiAvatar from '../../icons/AiAvatar';
import { AnimatedMessageRow } from '../../AnimatedMessageRow';
import { formatTimestamp } from '../../../utils/formatTimestamp';

interface Props {
  isNew?: boolean;
  bubbleText?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  createdAt: string;
  showTimestamp?: boolean;
}

const ProposalMessageRow = ({ isNew, bubbleText, children, footer, createdAt, showTimestamp = true }: Props) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <AnimatedMessageRow isNew={isNew}>
      <div style={styles.avatar}>
        <AiAvatar />
      </div>
      <div style={styles.messageContentAiProposal}>
        {bubbleText != null && bubbleText !== '' && <div style={styles.aiBubble}>{bubbleText}</div>}
        {children}
        {footer}
        {showTimestamp && <div style={styles.timestamp}>{formatTimestamp(createdAt)}</div>}
      </div>
    </AnimatedMessageRow>
  );
};

const getStyles = (_theme: AITTheme) => ({
  avatar: {
    flex: '0 0 48px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  messageContentAiProposal: {
    flex: 1,
    minWidth: 0,
    maxWidth: '100%'
  },
  aiBubble: {
    padding: '12px 16px',
    borderRadius: '8px',
    backgroundColor: '#f5f5f5',
    display: 'inline-block' as const
  },
  timestamp: {
    fontSize: '11px',
    color: '#7d7d7d',
    marginTop: '4px'
  }
});

export default ProposalMessageRow;
